

export const fieldPatterns = (isImportShipment, procedure) => {
  const validatePayment = (key) => (value, attribute) => {
    const procedureList = attribute.paymentType == "VAT" ? ["H2", "H5", "I2A", "I2B"] : ["H2", "H3", "H4", "I2A", "I2B"]
    return { presence: (attribute.paymentType && !procedureList.includes(procedure)) ? { message: `^${key} is mandatory`, allowEmpty: false } : false }


  }
  if (isImportShipment) {
    return (dependentParams = {}) => ({
      headerTab: {
        paymentDetails: {
          paymentType: { presence: { message: "^Payment Type is mandatory", allowEmpty: false } },
          eoriNo: validatePayment("Identification"),
          role: validatePayment("ROLE"),
          VAT: (value, attribute) => {
            const procedureList = attribute.paymentType == "VAT" ? ["H2", "H5", "I2A", "I2B"] : ["H2", "H3", "H4", "I2A", "I2B"]
            return { presence: (procedureList.includes(procedure) || procedureList.includes(procedure)) ? { message: `^${attribute.paymentType} Payment party is not required for procedures ${procedureList.toString()}`, allowEmpty: false } : false }
          }
        }
  
      },
      transportTab: {},
      itemsTab:{}
    })
  }
  return (dependentParams = {}) => ({
    headerTab: {
      paymentDetails: {
        paymentType: { presence: { message: "^Payment Type is mandatory", allowEmpty: false } },
        eoriNo: validatePayment("Identification"),
        role: validatePayment("ROLE"),
        VAT: (value, attribute) => {
          const procedureList = attribute.paymentType == "VAT" ? ["H2", "H5", "I2A", "I2B"] : ["H2", "H3", "H4", "I2A", "I2B"]
          return { presence: (procedureList.includes(procedure) || procedureList.includes(procedure)) ? { message: `^${attribute.paymentType} Payment party is not required for procedures ${procedureList.toString()}`, allowEmpty: false } : false }
        }
      }
    },
    transportTab: {},
    itemsTab:{}

  })
}
